/**
 * FLPage — the Floodlight page shell: the original BetOptimized ground
 * (black, a blue glow rising from the bottom and a faint purple bloom up top)
 * under the site header and tickers, and a scroll view padded below them.
 *
 *   <FLPage>{sections}</FLPage>
 *   <FLPage scroll={false}>{custom scroller}</FLPage>
 */
import React from 'react';
import { View, ScrollView, StyleSheet, Platform } from 'react-native';
import NavigationHeader from '../NavigationHeader';
import { useTicker } from '../../context/TickerContext';
import { IS_WEB } from '../../utils/motion';
import { ensureFloodlight } from './floodlightCss';
import { FL } from './theme';

/** The original home ground: blue glow from the bottom edge (HomeScreen blueGlow), plus a soft purple bloom. */
export const FL_GROUND = 'radial-gradient(ellipse 80% 60% at 50% 100%, rgba(30,80,220,0.18) 0%, transparent 70%), radial-gradient(ellipse 60% 40% at 15% 0%, rgba(162,89,255,0.10) 0%, transparent 70%)';

export default function FLPage({ children, scroll = true, bottom = 96, contentStyle, overlay }) {
    if (IS_WEB) ensureFloodlight();
    const { totalHeaderHeight } = useTicker();
    const top = (Platform.OS === 'web' ? totalHeaderHeight : 0);

    return (
        <View style={styles.root}>
            {IS_WEB && <View pointerEvents="none" aria-hidden testID="fl-ground" style={[styles.ground, { backgroundImage: FL_GROUND }]} />}
            <NavigationHeader />
            {scroll ? (
                <ScrollView
                    style={styles.scroll}
                    contentContainerStyle={[{ paddingTop: top, paddingBottom: bottom }, contentStyle]}
                    showsVerticalScrollIndicator={false}
                >
                    {children}
                </ScrollView>
            ) : (
                <View style={[styles.scroll, { paddingTop: top }, contentStyle]}>{children}</View>
            )}
            {overlay}
        </View>
    );
}

const styles = StyleSheet.create({
    root: { flex: 1, backgroundColor: FL.paper, ...(Platform.OS === 'web' ? { minHeight: '100vh' } : {}) },
    // Fixed so the glow stays put while the page scrolls, as on the original home.
    ground: { ...(Platform.OS === 'web' ? { position: 'fixed' } : { position: 'absolute' }), top: 0, left: 0, right: 0, bottom: 0 },
    scroll: { flex: 1 },
});
